import { Button } from "antd";

const BVConfirmedButton = () => {
	return (
		<Button
			type="primary"
			size={"large"}
			disabled={true}
			style={{
				color: "#006400",
				borderColor: "#999999",
				backgroundColor: "#d9d9d9",
				paddingInline: "19px"
			}}
		>
			{"Confirmed"}
		</Button>
	);
};

export default BVConfirmedButton;